/* eslint-disable no-console, no-undef*/
function validateExternalFunctions() {
    let testInputs = [10, 2000, 20000];

    if (typeof DarboVietosKaina != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "DarboVietosKaina"');
    } else {
        testInputs.forEach(input => {
            let value = DarboVietosKaina(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "DarboVietosKaina"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }

    if (typeof PajamosIRankas != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "PajamosIRankas"');
    } else {
        testInputs.forEach(input => {
            let value = PajamosIRankas(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "PajamosIRankas"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }

    if (typeof NeapmokestinamasPajamuDydis != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "NeapmokestinamasPajamuDydis"');
    } else {
        testInputs.forEach(input => {
            let value = NeapmokestinamasPajamuDydis(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "NeapmokestinamasPajamuDydis"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }

    if (typeof GyventojuPajamuMokestis != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "GyventojuPajamuMokestis"');
    } else {
        testInputs.forEach(input => {
            let value = GyventojuPajamuMokestis(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "GyventojuPajamuMokestis"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }

    if (typeof DarbuotojoSocDraudimoImoka != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "DarbuotojoSocDraudimoImoka"');
    } else {
        testInputs.forEach(input => {
            let value = DarbuotojoSocDraudimoImoka(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "DarbuotojoSocDraudimoImoka"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }

    if (typeof SveikatosDraudimoImoka != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "SveikatosDraudimoImoka"');
    } else {
        testInputs.forEach(input => {
            let value = SveikatosDraudimoImoka(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "SveikatosDraudimoImoka"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }

    if (typeof DarbdavioSocDraudimoImoka != 'function') {
        console.log('Konfiguracijos klaida: Neapibrezta funkcija "DarbdavioSocDraudimoImoka"');
    } else {
        testInputs.forEach(input => {
            let value = DarbdavioSocDraudimoImoka(input);
            if (typeof value != 'number') {
                console.log(`Konfiguracijos klaida: Klaidingai apibrezta funkcija "DarbdavioSocDraudimoImoka"; 
                        ivesciai ${input} grazino ne skaiciu o ${value}. 
                        Patikrinkite, kad funkcija turi return reiksme visoms if / else sakoms`);
            }
        });
    }
}

function calculateInvert(fn, value) {
    let step = Math.pow(10, Math.ceil(Math.log10(value)));
    let minStep = 0.1
    let x = 0;
    while(step > minStep) {
        while (fn(x + step) < value) {
            x += step;
        }
        step = step / 10;
    }
    x += step * 10;
    return x;
}

export default {
    validateExternalFunctions: validateExternalFunctions,
    beforeTaxToGPM: function(x) {
        return GyventojuPajamuMokestis(x);
    },
    beforeTaxToVSD: function(x) {
        return DarbuotojoSocDraudimoImoka(x);
    },
    beforeTaxToPSD: function(x) {
        return SveikatosDraudimoImoka(x);
    },
    beforeTaxToDSD: function(x) {
        return DarbdavioSocDraudimoImoka(x);
    },
    beforetaxToAftertax: function(x) {
        return PajamosIRankas(x);
    },
    aftertaxToBeforetax: function(x) {
        return calculateInvert(PajamosIRankas, x);
    },
    beforetaxToWorkplacecost: function(x) {
        return DarboVietosKaina(x);
    }
}
